import { Button } from '@v2/components/ui/button';
import { findCategoryPath } from './helpers';
import { Category } from './types';
import { ArrowLeftIcon, ArrowRightIcon } from '@v2/icons';
import React from 'react';

export interface CategoryItemProps {
  category: Category;
  allCategories: Category;
  onSelect: (category: Category) => void;
  showPath?: boolean;
  isBack?: boolean;
  isSubCategory?: boolean;
}

const classes = {
  Button: 'w-full justify-start bg-white hover:bg-gray-100 p-[10px]',
  Label: 'flex flex-1 flex-col text-left',
  Breadcrumbs:
    'text-xs text-muted-foreground mt-0.5 overflow-hidden text-ellipsis flex gap-1',
  BackWrapper: 'size-4'
};

export const CategorySelectItem = ({
  category,
  onSelect,
  showPath,
  isBack,
  isSubCategory,
  allCategories
}: CategoryItemProps) => {
  const path = findCategoryPath(category.id, allCategories);

  return (
    <Button
      variant="ghost"
      className={classes.Button}
      onClick={() => onSelect(category)}
    >
      {(isBack || isSubCategory) && (
        <div className={classes.BackWrapper}>
          {isBack && <ArrowLeftIcon className={'size-4'} />}
        </div>
      )}
      <div className={classes.Label}>
        <div>{category.name}</div>
        {showPath && path.length > 0 && (
            <div className={classes.Breadcrumbs}>
              {path.map((c, index) => (
                  <React.Fragment key={index}>
                    <div className={"inline-block"}>{c.name}</div>
                    {index < path.length - 1 && ' → '}
                  </React.Fragment>
              ))}
            </div>
        )}
      </div>
      {!isBack && category.children && !showPath && (
        <ArrowRightIcon className={'size-4'} />
      )}
    </Button>
  );
};
